// import DebugConsole from '@helper/functions/console';
import { isAxiosError } from 'axios';

import { tryCatch } from '@helper/functions/utility';

import { paymentAPI } from './api';
import { handleErrorMessage } from './shared';

export async function validateRecaptcha(token: string) {
  let url = `/bpointapi/validate-recaptcha`;

  const [err, data] = await tryCatch(() =>
    paymentAPI.post(url, {
      token,
    }),
  );

  if (err) {
    handleErrorMessage(err);
    return false;
  }

  return data.data;
}

export async function createAuthKey({
  healthEntityCode,
  paymentType,
  orderAmount,
  orderReference,
  international = false,
}) {
  try {
    let url = `/bpointapi/create-authkey`;

    const { data } = await paymentAPI.post(url, {
      healthEntityCode: healthEntityCode,
      paymentType: paymentType,
      orderAmount,
      orderReference,
    });

    return data;
  } catch (error) {
    handleErrorMessage(error);
    return false;
  }
}

export async function updateTxnDetails({
  authkey,
  healthEntityCode,
  paymentType,
  orderAmount,
  orderReference,
  international = false,
}) {
  try {
    let url = `/bpointapi/txn-details/${authkey}`;

    const { data } = await paymentAPI.put(url, {
      healthEntityCode: healthEntityCode,
      paymentType: paymentType,
      orderAmount,
      orderReference,
    });

    return data;
  } catch (error) {
    handleErrorMessage(error);
    return false;
  }
}

export type BpointSetupPayerAuthResponse = {
  iframe: {
    url: 'string';
    origin: 'string';
  };
  authentication: {
    status: 'InProgress' | 'Complete';
  };
};

export async function setupPayerAuth({
  authkey,
  healthEntityCode,
  paymentType,
}): Promise<false | BpointSetupPayerAuthResponse> {
  let url = `/bpointapi/setup-payer-auth`;

  const [err, data] = await tryCatch(() =>
    paymentAPI.post(url, {
      authkey,
      healthEntityCode,
      paymentType,
    }),
  );

  if (err) {
    handleErrorMessage(err);
    return false;
  }

  return data.data;
}

export async function processPayment({ authkey, ...others }) {
  const url = `/bpointapi/process-payment`;

  const [err, data] = await tryCatch(() =>
    paymentAPI.post(url, {
      authkey,
      ...others,
    }),
  );

  if (err) {
    if (isAxiosError(err)) {
      if (err.response.data) {
        return {
          status: err.response?.data?.status || 'ERROR',
          message: err.response?.data?.message || 'An error occurred while processing the payment',
        };
      }

      handleErrorMessage(err);
      return {
        status: 'ERROR',
        data: { message: 'An error occurred while processing the payment' },
      };
    }

    handleErrorMessage(err);
    return { status: 'ERROR', data: { message: 'An error occurred while processing the payment' } };
  }

  return data.data;
}

export const selectCCPaymentGateway = async (
  healthEntityCode: string,
  paymentType: string,
): Promise<string | false> => {
  let url = `/bpointapi/check-merchant-config`;

  const [err, data] = await tryCatch(() =>
    paymentAPI.post(url, {
      healthEntityCode,
      paymentType,
    }),
  );

  if (err) {
    handleErrorMessage(err);
    return false;
  }
  console.log('Data:', data);
  return data.data.flag;
};
